import { Skill } from '../types';

export const skillsData: Skill[] = [
  {
    id: "html-css-php-mysql",
    name: "HTML5/CSS3/PHP/MYSQL",
    level: 85,
    category: "frontend",
    description: "Web development technologies"
  },
  {
    id: "react",
    name: "React",
    level: 90,
    category: "frontend",
    description: "Modern React with hooks, context, and functional components"
  },
  {
    id: "nextjs",
    name: "Next.js",
    level: 85,
    category: "frontend",
    description: "Full-stack React framework with SSR, SSG, and API routes"
  },
  {
    id: "typescript",
    name: "TypeScript",
    level: 80,
    category: "frontend",
    description: "Typed JavaScript for better development experience"
  },
  {
    id: "tailwindcss",
    name: "Tailwind CSS",
    level: 85,
    category: "frontend",
    description: "Utility-first CSS framework for rapid UI development"
  },
  {
    id: "rails",
    name: "Rails",
    level: 35,
    category: "backend",
    description: "Ruby on Rails framework"
  },
  {
    id: "java",
    name: "Java",
    level: 85,
    category: "backend",
    description: "Java programming language"
  },
  {
    id: "nodejs",
    name: "Node.js",
    level: 85,
    category: "backend",
    description: "JavaScript runtime for server-side development"
  },
  {
    id: "express",
    name: "Express.js",
    level: 80,
    category: "backend",
    description: "Fast, unopinionated web framework for Node.js"
  },
  {
    id: "python",
    name: "Python",
    level: 90,
    category: "backend",
    description: "High-level programming language for backend development"
  },
  {
    id: "flask",
    name: "Flask",
    level: 80,
    category: "backend",
    description: "Lightweight Python web framework"
  },
  {
    id: "fastapi",
    name: "FastAPI",
    level: 85,
    category: "backend",
    description: "Modern, fast web framework for building APIs with Python"
  },
  {
    id: "uvicorn",
    name: "Uvicorn",
    level: 75,
    category: "backend",
    description: "Lightning-fast ASGI server for Python"
  },
  {
    id: "pydantic",
    name: "Pydantic",
    level: 80,
    category: "backend",
    description: "Data validation using Python type annotations"
  },
  {
    id: "mongoose",
    name: "Mongoose",
    level: 75,
    category: "backend",
    description: "MongoDB object modeling for Node.js"
  },
  {
    id: "pandas",
    name: "Pandas",
    level: 85,
    category: "backend",
    description: "Data manipulation and analysis library for Python"
  },
  {
    id: "numpy",
    name: "NumPy",
    level: 80,
    category: "backend",
    description: "Numerical computing library for Python"
  },
  {
    id: "yfinance",
    name: "yfinance",
    level: 75,
    category: "backend",
    description: "Python library for downloading financial data"
  },
  {
    id: "alpaca-py",
    name: "Alpaca-py",
    level: 70,
    category: "backend",
    description: "Python SDK for Alpaca trading API"
  },
  {
    id: "streamlit",
    name: "Streamlit",
    level: 75,
    category: "backend",
    description: "Python library for creating web applications"
  },
  {
    id: "google-genai",
    name: "Google Generative AI",
    level: 80,
    category: "backend",
    description: "Google's generative AI models and APIs"
  },
  {
    id: "axios",
    name: "Axios",
    level: 80,
    category: "backend",
    description: "Promise-based HTTP client for Node.js"
  },
  {
    id: "helmet",
    name: "Helmet",
    level: 75,
    category: "backend",
    description: "Security middleware for Express.js applications"
  },
  {
    id: "cors",
    name: "CORS",
    level: 80,
    category: "backend",
    description: "Cross-Origin Resource Sharing middleware"
  },
  {
    id: "rate-limiting",
    name: "Rate Limiting",
    level: 75,
    category: "backend",
    description: "API rate limiting and throttling implementation"
  },
  {
    id: "validation",
    name: "Input Validation",
    level: 85,
    category: "backend",
    description: "Data validation and sanitization techniques"
  },
  {
    id: "r",
    name: "R",
    level: 65,
    category: "ai-ml",
    description: "Statistical computing and graphics"
  },
  {
    id: "sas",
    name: "SAS",
    level: 95,
    category: "ai-ml",
    description: "Statistical analysis software"
  },
  {
    id: "android",
    name: "Android Development",
    level: 85,
    category: "mobile",
    description: "Android mobile app development"
  },
  {
    id: "ios",
    name: "iOS Development",
    level: 85,
    category: "mobile",
    description: "iOS mobile app development"
  },
  {
    id: "macos-development",
    name: "macOS Development",
    level: 80,
    category: "desktop",
    description: "Native macOS desktop application development using Swift and AppKit"
  },
  {
    id: "windows-development",
    name: "Windows Development",
    level: 75,
    category: "desktop",
    description: "Windows desktop application development using various frameworks"
  },
  {
    id: "linux-development",
    name: "Linux Development",
    level: 75,
    category: "desktop",
    description: "Linux desktop application development and cross-platform solutions"
  },
  {
    id: "cross-platform-desktop",
    name: "Cross-Platform Desktop",
    level: 80,
    category: "desktop",
    description: "Cross-platform desktop application development for macOS, Windows, and Linux"
  },
  {
    id: "matlab",
    name: "MATLAB",
    level: 85,
    category: "ai-ml",
    description: "Numerical computing environment"
  },
  {
    id: "cuda",
    name: "nVidia CUDA",
    level: 65,
    category: "ai-ml",
    description: "Parallel computing platform"
  },
  {
    id: "neural-nets",
    name: "Artificial & Deep Neural Nets",
    level: 65,
    category: "ai-ml",
    description: "Machine learning and neural networks"
  },
  {
    id: "rhel",
    name: "RHEL (Red Hat Linux)",
    level: 65,
    category: "devops",
    description: "Red Hat Enterprise Linux"
  },
  {
    id: "ubuntu",
    name: "Ubuntu",
    level: 65,
    category: "devops",
    description: "Ubuntu Linux distribution"
  },
  {
    id: "docker",
    name: "Docker",
    level: 85,
    category: "devops",
    description: "Containerization platform for application deployment and orchestration"
  },
  {
    id: "kubernetes",
    name: "Kubernetes",
    level: 80,
    category: "devops",
    description: "Container orchestration platform for automating deployment, scaling, and management"
  },
  {
    id: "prometheus",
    name: "Prometheus",
    level: 80,
    category: "devops",
    description: "Open-source monitoring and alerting system for cloud-native applications"
  },
  {
    id: "grafana",
    name: "Grafana",
    level: 80,
    category: "devops",
    description: "Open-source analytics and monitoring platform for metrics visualization"
  },
  {
    id: "ai-ml-macro",
    name: "AI & Machine Learning",
    level: 90,
    category: "ai-ml",
    description: "AI integration, LLMs, anomaly detection, root cause analysis, MLOps, model deployment, prompt engineering"
  },
  {
    id: "openai",
    name: "OpenAI",
    level: 85,
    category: "ai-ml",
    description: "OpenAI API integration, GPT models, embeddings, fine-tuning, and prompt engineering"
  },
  {
    id: "claude",
    name: "Claude",
    level: 80,
    category: "ai-ml",
    description: "Anthropic Claude API integration, conversation models, and safety-focused AI development"
  },
  {
    id: "llama",
    name: "Llama",
    level: 75,
    category: "ai-ml",
    description: "Meta's Llama models, local deployment, fine-tuning, and open-source LLM development"
  },
  {
    id: "gemini",
    name: "Gemini",
    level: 80,
    category: "ai-ml",
    description: "Google Gemini API integration, multimodal AI, and Google's generative AI models"
  },
  {
    id: "openrouter",
    name: "OpenRouter",
    level: 75,
    category: "ai-ml",
    description: "OpenRouter API integration, unified LLM access, and multi-model AI applications"
  },
  {
    id: "observability-macro",
    name: "Observability & Monitoring",
    level: 90,
    category: "devops",
    description: "Distributed tracing, metrics, logging, dashboards, alerting, incident response, real-time analytics"
  },
  {
    id: "cloud-devops-macro",
    name: "Cloud & DevOps",
    level: 90,
    category: "devops",
    description: "Kubernetes, Docker, Terraform, CI/CD, GitOps, multi-cloud, automation, SRE, platform engineering"
  },
  {
    id: "security-macro",
    name: "Security & Compliance",
    level: 85,
    category: "other",
    description: "RBAC, OIDC, secrets management, encryption, audit logging, compliance reporting"
  },
  {
    id: "data-eng-macro",
    name: "Data Engineering",
    level: 80,
    category: "backend",
    description: "Event-driven architecture, real-time streaming, Kafka, data pipelines, custom instrumentation"
  },
  {
    id: "platform-eng-macro",
    name: "Platform Engineering",
    level: 85,
    category: "devops",
    description: "Infrastructure as code, automation, reliability, scalability, modernization, cost optimization"
  },
  {
    id: "mongodb",
    name: "MongoDB",
    level: 80,
    category: "database",
    description: "NoSQL document database for modern applications"
  },
  {
    id: "mysql",
    name: "MySQL",
    level: 85,
    category: "database",
    description: "Relational database management system"
  },
  {
    id: "redis",
    name: "Redis",
    level: 80,
    category: "database",
    description: "In-memory data structure store used as database, cache, and message broker"
  },
  {
    id: "aws-s3",
    name: "AWS S3",
    level: 75,
    category: "database",
    description: "Cloud object storage for data archiving and analytics"
  },
  {
    id: "rsocket",
    name: "rSocket",
    level: 85,
    category: "backend",
    description: "Real-time bidirectional communication protocol over WebSocket for event-driven applications"
  },
  {
    id: "websocket",
    name: "WebSocket",
    level: 85,
    category: "backend",
    description: "Real-time web communication protocol for persistent bidirectional connections"
  },
  {
    id: "event-driven-arch",
    name: "Event-Driven Architecture",
    level: 90,
    category: "backend",
    description: "Pub/Sub patterns, real-time event streaming, and asynchronous message processing"
  },
  {
    id: "graphql",
    name: "GraphQL",
    level: 85,
    category: "backend",
    description: "Query language and runtime for APIs with declarative data fetching and flexible queries"
  },
  {
    id: "api-gateway",
    name: "API Gateway",
    level: 85,
    category: "backend",
    description: "API management with scaling, security, throttling, and configuration capabilities"
  },
  {
    id: "multi-tenant-apis",
    name: "Multi-Tenant APIs",
    level: 85,
    category: "backend",
    description: "Authorization models, channel-level validation, and tenant isolation patterns"
  },
  {
    id: "jenkins",
    name: "Jenkins",
    level: 80,
    category: "devops",
    description: "Continuous integration and automation server for building, testing, and deploying"
  },
  {
    id: "argocd",
    name: "ArgoCD",
    level: 80,
    category: "devops",
    description: "GitOps continuous delivery tool for Kubernetes with declarative application management"
  },
  {
    id: "argo-rollouts",
    name: "Argo Rollouts",
    level: 75,
    category: "devops",
    description: "Advanced deployment strategies and progressive delivery for Kubernetes applications"
  },
  {
    id: "service-mesh",
    name: "Service Mesh",
    level: 80,
    category: "devops",
    description: "Traffic management, service discovery, and observability for microservices"
  },
  {
    id: "declarative-resource-mgmt",
    name: "Declarative Resource Management",
    level: 85,
    category: "devops",
    description: "Infrastructure as code principles and declarative resource lifecycle management"
  },
  {
    id: "asset-lifecycle-mgmt",
    name: "Asset Lifecycle Management",
    level: 85,
    category: "devops",
    description: "Resource specification, tracking, and comprehensive lifecycle management platforms"
  },
  {
    id: "state-management",
    name: "State Management",
    level: 85,
    category: "backend",
    description: "Connection steering, health checks, presence state, and distributed state management"
  },
  {
    id: "client-connection-mgmt",
    name: "Client Connection Management",
    level: 85,
    category: "backend",
    description: "Authentication, authorization, and management of millions of client connections"
  },
  {
    id: "scalability-engineering",
    name: "Scalability Engineering",
    level: 90,
    category: "backend",
    description: "Distributed systems design for handling millions of concurrent connections and high throughput"
  },
  {
    id: "distributed-systems",
    name: "Distributed Systems",
    level: 85,
    category: "backend",
    description: "Decoupled teams, independent deployments, and microservices architecture patterns"
  },
  {
    id: "splunk",
    name: "Splunk",
    level: 80,
    category: "devops",
    description: "Log management, monitoring, and analytics platform for operational intelligence"
  },
  {
    id: "wavefront",
    name: "Wavefront",
    level: 75,
    category: "devops",
    description: "Observability and monitoring solutions for cloud-native applications"
  },
  {
    id: "idps",
    name: "IDPS",
    level: 75,
    category: "other",
    description: "Intrusion Detection and Prevention Systems for security monitoring and threat response"
  }
]; 